import React from "react";
import { Container, InnerCircle, Label, Spinner } from "./style";

// Componente de Loading
export default function LoadingRH() {
    return (
      <Container>
        <Spinner>
          <InnerCircle>
            <Label>RH</Label>
          </InnerCircle>
        </Spinner>
      </Container>
    );
  }
